import * as remoteAction from "../remoteAction";

export type GetRewardsActionSuccess = remoteAction.MerchantRemoteResponse<
  "GET_REWARDS_SUCCESS",
  any
>;
export type GetRewardsActionFailure = remoteAction.MerchantRemoteResponse<
  "GET_REWARDS_FAILURE",
  any
>;
export type GetRewardsActionRequest = remoteAction.MerchantRemoteResponse<
  "GET_REWARDS_REQUEST",
  any
>;

export interface GetRewardsAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_REWARDS_REQUEST";
    success: "GET_REWARDS_SUCCESS";
    failure: "GET_REWARDS_FAILURE";
  };
}

export function getRewardsAction(): GetRewardsAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_REWARDS_FAILURE",
      request: "GET_REWARDS_REQUEST",
      success: "GET_REWARDS_SUCCESS",
    },
    https: true,
    url: `/rewards/rewards`,
  };
}
